import { useContext, useEffect, useState } from "react";
import { useRaffaella } from "@eriksdigital/raffaella";
import { LanguageContext } from "@eriksdigital/atomic-ui/components";
import { constructShoppingUrl } from "../../utils/shopUtils";

const useShoppingCartUrl = () => {
  const [shoppingCartUrl, setShoppingCartUrl] = useState("/");
  const [salesOrganization] = useRaffaella("salesOrganization");
  const [user] = useRaffaella("user");
  const { erpSystem, language } = useContext(LanguageContext) as {
    erpSystem: any;
    language: any;
  };

  const loginUrl = user?.data?.loginUrl;

  useEffect(() => {
    if (language && erpSystem && (loginUrl || salesOrganization?.data)) {
      const url = constructShoppingUrl(
        salesOrganization?.data,
        language,
        erpSystem,
        loginUrl
      );
      setShoppingCartUrl(url);
    }
  }, [salesOrganization?.data, loginUrl, erpSystem, language]);

  return shoppingCartUrl;
};

export { useShoppingCartUrl };
